import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useLanguage } from '../../i18n/LanguageContext';

const tabLabels = {
    en: ["San Jose, CA 95112 – USA", "Riyadh, 3181 – KSA"],
    ar: ["سان خوسيه، كاليفورنيا 95112 – الولايات المتحدة", "الرياض، 3181 – السعودية"],
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

export default function VerticalTabs() {
    const { lang, isRtl } = useLanguage();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box
            sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: '100%' }} className="locationTabPills"
        >
            <Tabs
                orientation="vertical"
                className="orientationTabPills"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label={lang === 'ar' ? 'مواقع المكاتب' : 'Office locations'}
                sx={{ [isRtl ? 'borderLeft' : 'borderRight']: 1, borderColor: 'divider' }}
            >
                {/* <Tab label="JeddahIndustrial City, Phase 5 Jeddah, Saudi Arabia" {...a11yProps(0)} className="tabBtn" /> */}
                <Tab label={tabLabels[lang][0]} {...a11yProps(0)} className="tabBtn" />
                <Tab label={tabLabels[lang][1]} {...a11yProps(1)} className="tabBtn" />
                {/* <Tab label="JeddahIndustrial City, Phase 5 Jeddah, Saudi Arabia" {...a11yProps(4)} className="tabBtn" /> */}
            </Tabs>
            <TabPanel value={value} index={0} className="rightSideData">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2218.3666956776256!2d-121.89138653766608!3d37.33989563073499!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fcc97f16f4f4d%3A0x6e1daaa9691e3dd3!2s196%20N%203rd%20St%2C%20San%20Jose%2C%20CA%2095112%2C%20USA!5e0!3m2!1sen!2seg!4v1757576537400!5m2!1sen!2seg"
                    title="USA"
                    width="100%"
                    height="100%"
                    style={{ border: '0' }}
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade">
                </iframe>
            </TabPanel>
            <TabPanel value={value} index={1} className="rightSideData">
                <iframe
                    src="https://www.google.com/maps?q=6247+An+Namrah,+3181,+Al+Hamra+District,+Riyadh,+Saudi+Arabia&output=embed"
                    title="Riyadh"
                    width="100%"
                    height="100%"
                    style={{ border: '0' }}
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade">
                </iframe>
            </TabPanel>
            {/* <TabPanel value={value} index={1} className="rightSideData">
                <img src="/icons/mapimage1.png" style={{width:'100%'}} />
            </TabPanel> */}
            {/* <TabPanel value={value} index={2} className="rightSideData">
                <img src="/icons/mapimage.png" />
            </TabPanel>
            <TabPanel value={value} index={3} className="rightSideData">
                <img src="/icons/mapimage.png" />
            </TabPanel>
            <TabPanel value={value} index={4} className="rightSideData">
                <img src="/icons/mapimage.png" />
            </TabPanel> */}
        </Box>
    );
}